import nid from '../components/pages/app/servers/nid.png';
import itali from '../components/pages/app/servers/itali.png';
import polsh from '../components/pages/app/servers/polsh.png';
import kaz from '../components/pages/app/servers/kaz.png';
import latvia from '../components/pages/app/servers/latvia.png';
import tur from '../components/pages/app/servers/tur.png';
import rus from '../components/pages/app/servers/rus.png';
import usa from '../components/pages/app/servers/usa.png';
import japan from '../components/pages/app/servers/japan.png';
import spain from '../components/pages/app/servers/spain.png';
import france from '../components/pages/app/servers/france.png';
import germany from '../components/pages/app/servers/germany.png';
import wireguard from '../components/pages/app/servers/wireguard.png';
import amneziaWG from '../components/pages/app/servers/amneziaWG.png';
import vless from '../components/pages/app/servers/vless.png';

export function getCountryIcon(country) {
    switch (country) {
        case 'Нидерланды':
            return nid;
        case 'Италия':
            return itali;
        case 'Польша':
            return polsh;
        case 'Казахстан':
            return kaz;
        case 'Латвия':
            return latvia;
        case 'Турция':
            return tur;
        case 'Россия':
            return rus;
        case 'США':
            return usa;
        case 'Япония':
            return japan;
        case 'Испания':
            return spain;
        case 'Франция':
            return france;
        case 'Германия':
            return germany;
        default:
            return null;
    }
}

export function getVlessInbound(clientType) {
    const c = String(clientType || '').trim();
    if (!c.toLowerCase().startsWith('vless')) return null;
    const parts = c.split(' ').filter(Boolean);
    return parts.length >= 2 ? parts[1] : null;
}

export function getProtocolIconSrc(protocol) {
    if (protocol === 'Wireguard') return wireguard;
    if (protocol === 'AmneziaWG') return amneziaWG;
    if (protocol === 'VLESS') return vless;
    return null;
}

export function getProtocolAndSubprotocol(clientType) {
    const c = String(clientType || '').trim();
    if (c.toLowerCase().startsWith('vless')) {
        const inbound = getVlessInbound(c);
        return { protocol: 'VLESS', subprotocol: inbound || '—' };
    }
    if (c === 'Wireguard') return { protocol: 'Wireguard', subprotocol: '' };
    if (c === 'AmneziaWG') return { protocol: 'AmneziaWG', subprotocol: '' };
    return { protocol: c || '—', subprotocol: '—' };
}

/** ID для отображения: без префиксов awg_, ws_, grpc_, tcp_ */
export function formatConfigDisplayId(name) {
    if (name == null || name === '') return '';
    return String(name)
        .replace(/^awg_/i, '')
        .replace(/^ws_/i, '')
        .replace(/^grpc_/i, '')
        .replace(/^tcp_/i, '');
}
